export default "__VITE_ASSET__CzEtNyH8__"